const currentYear = new Date().getFullYear();

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#3D1F08] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">

          {/* Col 1: Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-lg flex-shrink-0">
                <i className="ri-fire-fill text-white text-lg"></i>
              </div>
              <div>
                <p className="font-extrabold text-lg text-white leading-tight">Stufe a Pellet</p>
                <p className="text-orange-300 text-sm font-semibold">Ravenna</p>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              Partner certificato per l&apos;installazione e manutenzione di stufe a pellet a Ravenna.
              Qualità, sicurezza e risparmio energetico garantiti dal 2010.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              <a
                href="https://wa.me/393806328251"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="WhatsApp"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full text-white/60 hover:text-orange-300 hover:border-orange-300 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-base"></i>
              </a>
            </div>
          </div>

          {/* Col 2: Links */}
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-white/40 mb-5">Navigazione</p>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Chi Siamo', id: 'chi-siamo' },
                { label: 'Servizi', id: 'servizi' },
                { label: 'Recensioni', id: 'recensioni' },
                { label: 'Contattaci', id: 'contatti' },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-left text-sm text-white/60 hover:text-orange-300 transition-colors cursor-pointer w-fit"
                >
                  {link.label}
                </button>
              ))}
            </div>

            <p className="text-xs font-bold uppercase tracking-widest text-white/40 mt-7 mb-5">Servizi</p>
            <div className="flex flex-col gap-3">
              {['Installazione', 'Manutenzione', 'Riparazioni', 'Consulenza'].map((s) => (
                <button
                  key={s}
                  onClick={() => scrollTo('servizi')}
                  className="text-left text-sm text-white/60 hover:text-orange-300 transition-colors cursor-pointer w-fit"
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          {/* Col 3: Contacts */}
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-white/40 mb-5">Contatti</p>
            <div className="flex flex-col gap-5">
              <div className="flex gap-3 items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-fill text-orange-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-white/40 mb-0.5 uppercase tracking-wide">Indirizzo</p>
                  <p className="text-sm text-white/80">Largo Firenze</p>
                  <p className="text-sm text-white/80">48121 Ravenna (RA), Italia</p>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-phone-fill text-orange-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-white/40 mb-0.5 uppercase tracking-wide">Telefono</p>
                  <a
                    href="tel:+393806328251"
                    className="text-sm text-orange-300 hover:text-orange-200 transition-colors cursor-pointer font-semibold"
                  >
                    +39 380 632 8251
                  </a>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg flex-shrink-0">
                  <i className="ri-time-fill text-orange-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-white/40 mb-0.5 uppercase tracking-wide">Orari</p>
                  <p className="text-sm text-white/80 font-semibold">Aperto 24/7</p>
                  <p className="text-xs text-white/40">Sempre disponibili</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/40">
            &copy; {currentYear} Stufe a Pellet Ravenna. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-white/40 hover:text-orange-300 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <span className="text-white/20">|</span>
            <a href="#" className="text-xs text-white/40 hover:text-orange-300 transition-colors cursor-pointer">
              Cookie Policy
            </a>
            <span className="text-white/20">|</span>
            <span className="text-xs text-white/40">P.IVA: 02345678901</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
